module.exports = __webpack_public_path__ + "static/dassault-systemes-logo-fc86341bfde5b3ad4c64e7cc1ba1c09d.jpg";